// export const  uri = "https://dev.backend.algovicrm.com/api";
// export const  cdn = "https://dev.backend.algovicrm.com/";

import { apiUrl } from "services/config/secrets";

// export const  uri = "http://127.0.0.1:8000/api";
// export const  cdn = "http://127.0.0.1:8000/";

export const  uri = `${apiUrl}/api`;
export const  cdn = apiUrl + "/";